import { render, staticRenderFns } from "./cn-claim.vue?vue&type=template&id=5962f672"
import script from "./cn-claim.vue?vue&type=script&lang=js"
export * from "./cn-claim.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports